var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FFFAE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 5.83333C9.79094 5.83333 8.00008 7.62419 8.00008 9.83333C8.00008 12.0425 9.79094 13.8333 12.0001 13.8333C14.2092 13.8333 16.0001 12.0425 16.0001 9.83333C16.0001 7.62419 14.2092 5.83333 12.0001 5.83333ZM6.66675 9.83333C6.66675 6.88781 9.05456 4.5 12.0001 4.5C14.9456 4.5 17.3334 6.88781 17.3334 9.83333C17.3334 12.7789 14.9456 15.1667 12.0001 15.1667C9.05456 15.1667 6.66675 12.7789 6.66675 9.83333Z",
    fill: "#F8B133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.439 13.0925C14.804 13.0441 15.1391 13.3007 15.1876 13.6657L15.9942 19.7457C16.0279 19.9995 15.9133 20.2501 15.6993 20.3906C15.4854 20.5312 15.2099 20.5368 14.9904 20.4051L12 18.6109L9.00968 20.4051C8.79016 20.5368 8.51462 20.5312 8.30066 20.3906C8.0867 20.2501 7.97211 19.9994 8.00582 19.7456L8.81249 13.6723C8.86096 13.3073 9.19614 13.0507 9.56113 13.0992C9.92611 13.1477 10.1827 13.4829 10.1342 13.8479L9.50965 18.5502L11.657 17.2618C11.8681 17.1351 12.1319 17.1351 12.343 17.2618L14.4906 18.5503L13.8658 13.8411C13.8174 13.4761 14.074 13.141 14.439 13.0925Z",
    fill: "#F8B133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiAward);
export default __webpack_public_path__ + "static/media/FiAward.3d2eca7a986ad0610658000a3d0f078c.svg";
export { ForwardRef as ReactComponent };